
import {get} from 'lodash-es'

import store from 'store'

export default class RoleOption {

  static ROLE_VENDOR = 'vendor'
  static ROLE_ADMIN  = 'admin'
  static ROLE_STAFF  = 'staff'
  static ROLE_STORE  = 'store'

  // 店舗配列から権限オプション配列を作成する
  static make(stores) {
    let roles = [
      new RoleOption({
        label: '管理者',
        data: {
          role: this.ROLE_ADMIN,
          store_code: '',
        },
      }),
      new RoleOption({
        label: '本部',
        data: {
          role: this.ROLE_STAFF,
          store_code: '',
        },
      }),
    ]

    if(get(store.state, 'config.auth.role') === this.ROLE_VENDOR) {
      roles = [
        new RoleOption({
          label: 'ベンダ',
          data: {
            role: this.ROLE_VENDOR,
            store_code: '',
          },
        }),
        ...roles,
      ]
    }

    if(stores != null) {
      const unique = {}
      const uniqueStores = stores.filter(store => {
        if(unique[store.store_code] == null) {
          unique[store.store_code] = true
          return true
        }
      })

      roles = roles.concat(uniqueStores.map(store =>
        new RoleOption({
          label: '店舗(' + store.name + ')',
          data: {
            role: this.ROLE_STORE,
            store_code: store.store_code,
          },
        })
      ))
    }

    return roles
  }

  //
  constructor(object) {
    Object.assign(this, object)
    this.value = this.constructor.key(this.data)
    this.key = this.constructor.key(this.data)
  }

  static key({role, store_code}) {
    if(role == null) {
      return null
    }
    return role === 'store'
      ? role + '/' + store_code
      : role
  }
}
